import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  LOCALE_ID,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewChild
} from '@angular/core';
import { Subscription } from 'rxjs';
import {
  Components,
  FormioAlert,
  FormioComponent,
  FormioForm
} from '@formio/angular';
import { environment } from '../../../../environments/environment';
import { Formio, Templates } from 'formiojs';
// @ts-ignore TS7016: Could not find a declaration file for module
import { jsonLogic as realJsonLogic } from 'formiojs/utils/utils';
// @ts-ignore TS7016: Could not find a declaration file for module
import jsonLogic from 'json-logic-extension';
// @ts-ignore
import FormioLeafletMap from 'formio-leaflet-map';
// @ts-ignore
import FormioDropdown from 'formio-dropdown';
import QrCode, {
  template as QrCodeTemplate
} from '../../form/qrcode-component';
import { FormioPluginService } from '../../../services/formio-plugin.service';
import {
  MyAccountService,
  MyAccountServiceResponse
} from '../../../services/my-account.service';
import { GlobalStateProviderService } from '../../../services/global-state-provider.service';
import { Service } from '@models/service';
import { BpaSettingsService } from '../../../services/bpa-settings.service';
import { BPASettings } from '@models/bpa-settings';
import { EregistrationsTranslationService } from '../../../services/eregistrations-translation.service';
import { WebsocketService } from '../../../services/websocket.service';
import { WebSocketMessageType } from '../../../enums';

Object.keys(jsonLogic.customOperations).forEach((k) => {
  // eslint-disable-next-line security/detect-object-injection -- k from Object.keys() iteration
  realJsonLogic.add_operation(k, jsonLogic.customOperations[k]);
});

Templates.templates.bootstrap.modalPreview.form = `<button lang="en" class="btn btn-primary btn-md open-modal-button form-control {{ctx.component.customClasses?.join(' ')}}" ref="openModal">
  {% if (ctx.leftIcon) { %}<span class="{{ctx.leftIcon}}"></span>{% } %}
  {{ ctx.buttonLabel || ctx.t(ctx.component.title) }}
  {% if (ctx.buttonLabel) { %}
    <i class="fa fa-external-link-square"></i>
  {% } %}
  {% if (ctx.rightIcon) { %}<span class="{{ctx.rightIcon}}"></span>{% } %}
</button>`;

// @ts-ignore
const FormioLeafletMapComponent = FormioLeafletMap.Class(
  Components.components.field
);
// @ts-ignore
Formio.registerComponent(
  FormioLeafletMapComponent.type,
  FormioLeafletMapComponent
);
Templates.templates.bootstrap[FormioLeafletMapComponent.type] =
  FormioLeafletMap.template;

// @ts-ignore
Formio.registerComponent(QrCode.type, QrCode);
Templates.templates.bootstrap[QrCode.type] = QrCodeTemplate;

// @ts-ignore
const FormioDropdownComponent = FormioDropdown.Class(
  Components.components.panel
);
// @ts-ignore
Formio.registerComponent(FormioDropdownComponent.type, FormioDropdownComponent);
Templates.templates.bootstrap[FormioDropdownComponent.type] =
  FormioDropdown.template;

@Component({
  selector: 'app-my-account-page',
  templateUrl: './my-account-page.component.html'
})
export class MyAccountPageComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  @ViewChild('myAccountFormSection') section!: ElementRef;

  form: FormioForm | any = {};
  formioComponent!: FormioComponent;

  formSchema: any;
  formOpts: any;
  renderOptions: any = {
    buttonSettings: {
      showCancel: false,
      showPrevious: false,
      showNext: false,
      showSubmit: false
    },
    noDefaults: true,
    decimalSeparator: null,
    i18n: {
      delimiter: null
    },
    baseApiUrl: environment.BASE_URL
  };
  submission: any = {};
  refreshForm = new EventEmitter();
  listenerFns: Function[] = []; // Store cleanup functions for event listeners
  private bpaSettingsSubscription?: Subscription;
  private wsSubscription?: Subscription;

  observer: IntersectionObserver | null;
  mutationObserver: MutationObserver | null;
  observedFormioAlertsElement!: Element | null;
  intersectionElement!: Element | null;

  observerCallback(entries: IntersectionObserverEntry[]) {
    if (entries.length === 1) {
      if (
        !entries[0].isIntersecting &&
        this.formioComponent?.alerts?.alerts?.length > 0
      ) {
        this.observedFormioAlertsElement?.classList.add('floating-alerts');
      } else {
        this.observedFormioAlertsElement?.classList.remove('floating-alerts');
      }

      const alertsIsValidArray =
        this.formioComponent?.alerts?.alerts?.length > 0;
      const atLeastOneErrorPresent = this.formioComponent?.alerts?.alerts?.some(
        (each: FormioAlert) => each.type !== 'success'
      );
      if (this.observedFormioAlertsElement) {
        this.renderer.setStyle(
          this.observedFormioAlertsElement,
          'opacity',
          '1'
        );
        if (!alertsIsValidArray || !atLeastOneErrorPresent) {
          this.renderer.setStyle(
            this.observedFormioAlertsElement,
            'opacity',
            '0'
          );
        }
      }
    }
  }
  mutationCallback(mutations: MutationRecord[]) {
    if (!this.intersectionElement) {
      mutations.forEach((mutation) => {
        if (mutation.target.nodeName === 'FORMIO-ALERTS') {
          // formio-alerts has appeared in the DOM, start listening to an invisible element near it
          // being scrolled out of view
          let alertsElement = (this.observedFormioAlertsElement = <Element>(
            mutation.target
          ));
          const validationsErrorMsg = $localize`:@@Validation errors:Validation errors`;
          (alertsElement as HTMLElement).dataset['validationMessage'] =
            validationsErrorMsg;
          this.intersectionElement = document.querySelector(
            '.alerts-intersection-control'
          );
          if (!this.intersectionElement) {
            this.intersectionElement = document.createElement('div');
            alertsElement.insertAdjacentElement(
              'afterend',
              this.intersectionElement
            );
            this.intersectionElement.classList.add(
              'alerts-intersection-control'
            );
            this.intersectionElement.setAttribute(
              'style',
              '--alerts-height: ' + alertsElement.clientHeight + 'px'
            );
          }
          this.observer?.observe(this.intersectionElement);
        }
      });
    }
  }

  constructor(
    @Inject(LOCALE_ID) private readonly locale: string,
    private readonly renderer: Renderer2,
    private readonly globalStateProviderService: GlobalStateProviderService,
    private readonly myAccountService: MyAccountService,
    private readonly bpaSettingService: BpaSettingsService,
    private readonly eregistrationsTranslationService: EregistrationsTranslationService,
    private readonly webSocket: WebsocketService,
    private readonly formioPluginService: FormioPluginService
  ) {
    this.fireAnyEvent = this.fireAnyEvent.bind(this);
    this.renderOptions.hooks = {
      attachTabs: this.attachTabsComponent.bind(this)
    };
    if ('IntersectionObserver' in window) {
      this.observer = new IntersectionObserver(
        this.observerCallback.bind(this),
        {
          rootMargin: '-40px 0px 1000px'
        }
      );
    } else {
      this.observer = null;
    }
    if ('MutationObserver' in window) {
      this.mutationObserver = new MutationObserver(
        this.mutationCallback.bind(this)
      );
    } else {
      this.mutationObserver = null;
    }
  }

  ngOnInit() {
    this.formioPluginService.registerPlugins();
    this.bpaSettingsSubscription = this.bpaSettingService
      .getBpaSettings$()
      .subscribe((bpaSettings: BPASettings | null) => {
        if (bpaSettings) {
          this.renderOptions.decimalSeparator = bpaSettings.decimalSeparator;
          this.renderOptions.i18n.delimiter = bpaSettings.delimiter;
        }
      });
    this.myAccountService.loadData().subscribe({
      next: (response) => {
        this.initForm(response);
      },
      error: (err) => {
        console.error('Error loading my account data:', err);
      }
    });
    this.wsSubscription = this.webSocket.messageReceived$.subscribe(
      (message) => {
        if (message?.type === WebSocketMessageType.FILE_STATE_UPDATE) {
          this.reloadMyApplicationsGrid();
        }
      }
    );
  }

  ngAfterViewInit(): void {
    this.mutationObserver?.observe(this.section.nativeElement, {
      subtree: true,
      childList: true
    });
  }

  getCSSClass(): string {
    let cssClasses = '';
    if (!this.formOpts?.service?.show_page_name) {
      cssClasses += 'pagename-off';
    }

    return cssClasses;
  }

  attachTabsComponent(element: Element) {
    if (this.observer) {
      this.observer.observe(element);
    }
  }

  fireCustomEvent(event: any): void {
    if (!event) {
      console.error('Unrecognized custom event:', event);
      return;
    }

    try {
      // Your custom handling logic
    } catch (err) {
      console.error('Error in Custom Event:', err);
    }

    if (environment.DEBUG_MODE) {
      console.log('Formio fired event', event);
    }
  }

  fireAnyEvent(event: string, ...data: any) {
    if (event === 'formio.selectShowDropdown') {
      const comp = data[0];
      comp.element.closest('.formio-component-tabs')?.classList.add('unstick');
    } else if (event === 'formio.selectHideDropdown') {
      const comp = data[0];
      comp.element
        .closest('.formio-component-tabs')
        ?.classList.remove('unstick');
    }
  }

  onFormReady(formioComponent: FormioComponent): void {
    this.form = formioComponent.formio;
    this.formioComponent = formioComponent;

    this.globalStateProviderService.loadedFormChanged(
      this.form,
      this.formOpts,
      this.submission,
      null
    );

    window.wizard = this.form;

    this.form.events.onAny(this.fireAnyEvent);
  }

  initForm(myAccountServiceResponse?: MyAccountServiceResponse) {
    if (!myAccountServiceResponse) {
      this.myAccountService.loadData().subscribe({
        next: (response) => {
          this.initForm(response);
        },
        error: (err) => {
          console.error('Error loading my account data:', err);
        }
      });

      return;
    }

    const service: Service = {
      id: null,
      service_id: 'myaccountpage',
      name: 'My Account Page',
      is_publicly_visible: true,
      show_page_name: false
    };
    this.globalStateProviderService.serviceChanged(service);

    this.submission.data = myAccountServiceResponse.my_account_page_data || {};
    this.formOpts = { allow_anonymous: false, submit_allowed: false };

    // Set up translations via unified service, then continue form setup
    const lang = this.locale.split('-')[0].toLowerCase();
    this.renderOptions.language = lang;

    const continueSetup = (translationsDict: Record<string, string>) => {
      // eslint-disable-next-line security/detect-object-injection -- lang from environment config
      this.renderOptions.i18n[lang] = translationsDict;

      // Set formSchema AFTER translations are ready (triggers *ngIf="formSchema" rendering)
      this.formSchema = myAccountServiceResponse.my_account_page_schema;
      if (
        this.formSchema &&
        typeof this.formSchema === 'object' &&
        Object.keys(this.formSchema).length === 0
      ) {
        this.formSchema = null;
      }

      this.continueMyAccountFormSetup();
    };

    const myAccountServiceId =
      myAccountServiceResponse.my_account_page_service_id;
    if (myAccountServiceId) {
      this.eregistrationsTranslationService
        .mergeServiceTranslations(myAccountServiceId, lang)
        .subscribe((merged) => continueSetup(merged));
    } else {
      const base =
        this.eregistrationsTranslationService.resetToBaseTranslations();
      continueSetup(base);
    }
  }

  private continueMyAccountFormSetup(): void {
    const allowedAttrs = [
      'ref',
      'src',
      'url',
      'data-oembed-url',
      'onclick',
      'onchange',
      'style',
      'id',
      'checked',
      'width',
      'height',
      'hidden',
      'stroke-width',
      'fill',
      'r',
      'cx',
      'cy',
      'stroke-linecap',
      'data'
    ];

    const allowedTags = ['object', 'iframe'];
    this.renderOptions.sanitizeConfig = {
      allowedAttrs: allowedAttrs,
      addAttr: allowedAttrs,
      allowedTags: allowedTags,
      addTags: allowedTags
    };
    // Not documented anywhere, but without this, draft files become forgetful - some data isn't saved or is set to ""
    this.renderOptions.submission = this.submission;
    this.renderOptions.submission.data.is_submit_allowed = false;
    this.listenerFns.forEach((fn) => fn());
    this.listenerFns = [];
    this.listenerFns.push(
      this.renderer.listen(window, 'goToNextPage', () => {})
    );
    this.listenerFns.push(this.renderer.listen(window, 'validate', () => {}));
    this.listenerFns.push(this.renderer.listen(window, 'saveDraft', () => {}));
    this.listenerFns.push(this.renderer.listen(window, 'saveA5', () => {}));
    this.listenerFns.push(this.renderer.listen(window, 'saveGUIDE', () => {}));
    this.listenerFns.push(
      this.renderer.listen(window, 'saveDOCUMENT', () => {})
    );
    this.listenerFns.push(
      this.renderer.listen(window, 'savePAYMENTPAGE', () => {})
    );
    this.listenerFns.push(
      this.renderer.listen(window, 'saveSENDPAGE', () => {})
    );
  }

  private reloadMyApplicationsGrid(): void {
    if (typeof this.form?.everyComponent !== 'function') {
      return;
    }
    this.form.everyComponent((component: any) => {
      if (
        component.originalComponent?.tags?.includes('Dashboard-my-applications')
      ) {
        component.emit(`${component.key}.loadList`);
        return false;
      }
      return true;
    });
  }

  async ngOnDestroy() {
    this.globalStateProviderService.serviceChanged(null);
    this.listenerFns.forEach((fn) => fn());
    this.observer?.disconnect();
    this.mutationObserver?.disconnect();
    if (this.bpaSettingsSubscription) {
      this.bpaSettingsSubscription.unsubscribe();
    }
    this.wsSubscription?.unsubscribe();
  }
}
